// extracted by mini-css-extract-plugin
module.exports = {"Forms":"Settings_Forms__31GPX","Form":"Settings_Form__1h4HJ","TabList":"Settings_TabList__35IgZ","TabListPanelSelected":"Settings_TabListPanelSelected__1jYMD"};